import { render, staticRenderFns } from "./outHospital.vue?vue&type=template&id=5ec2e237&scoped=true&"
import script from "./outHospital.vue?vue&type=script&lang=js&"
export * from "./outHospital.vue?vue&type=script&lang=js&"
import style0 from "./outHospital.vue?vue&type=style&index=0&id=5ec2e237&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec2e237",
  null
  
)

export default component.exports